export default (node) => {
  const parent = node.parentElement;
  const html = node.innerHTML;
  $(parent).replaceWith(html); // remove question container
  tinymce.activeEditor.fire('change'); // eslint-disable-line no-undef
};
